export interface ServiceRequestStatus {
  id: string;
  value: string;
  label: string;
  color: string;
  isDefault: boolean;
}

export const DEFAULT_SERVICE_REQUEST_STATUSES: ServiceRequestStatus[] = [
  { id: 'status_pending', value: 'pending', label: 'Pending', color: '#6b7280', isDefault: true },
  { id: 'status_completed', value: 'completed', label: 'Completed', color: '#10d961', isDefault: true },
  { id: 'status_canceled', value: 'canceled', label: 'Canceled', color: '#ff3535', isDefault: true }
];

export const FALLBACK_SERVICE_REQUEST_STATUSES = [
  { value: "pending", label: "Pending", color: "#6b7280" },
  { value: "scheduled", label: "Scheduled", color: "#f59e0b" },
  { value: "in_progress", label: "In Progress", color: "#3b82f6" },
  { value: "completed", label: "Completed", color: "#10b981" },
  { value: "canceled", label: "Canceled", color: "#ef4444" },
];
